import { WHY_CARD_DATA } from '@/data/franchise/data';
import WhyCard from './why-card';

export default function WhySection() {
  return (
    <section className="desktop:web-w desktop:mx-auto">
      {/* 페이지 h1 은 위 "가맹문의"(PageHeader) — 섹션 제목은 다른 섹션처럼 h2 다 */}
      <h2 className="desktop:mt-20 desktop:pb-7 mt-10 text-center">
        <div className="typo-28 text-level-1 desktop:typo-50 desktop:pb-9 pb-5 font-black">
          왜?
          <span className="text-main-orange"> 드라이빙존 운전면허 </span>
          인가
        </div>
        <div className="typo-24 text-level-2 desktop:typo-40 desktop:leading-[60px] leading-snug font-semibold">
          초기 창업 비용의 부담 최소화 등 <br />
          <span className="font-extrabold">
            여러분의 성공적인 창업을 위해
          </span>{' '}
          <br className="desktop:hidden" />
          최선을 다하겠습니다.
        </div>
      </h2>
      <div className="desktop:grid-cols-3 desktop:pb-25 grid grid-cols-1 gap-5 pt-10 pb-18">
        {WHY_CARD_DATA.map((item) => (
          <WhyCard key={item.idx} {...item} />
        ))}
      </div>
    </section>
  );
}
